import OPEN_VIEWS_MODES from "../../../constants/openViewsModes";
import { createFromJS } from "../../../types";
import combineReducersWithGlobal from "../../combineReducersWithGlobal";
import activeView from "./activeView";
import byId from "./byId";
import byIdModesCrossReducer from "./byIdModesCrossReducer";
import layout from "./layout";

const doesOpenViewModeMatchCurrentMode = openViewMode => {
  let result = false;
  // #!if tablet === true
// result = openViewMode === OPEN_VIEWS_MODES.tablet;
  // #!elseif mobile === true
// result = openViewMode === OPEN_VIEWS_MODES.mobileLandscape;
  // #!else
  result = openViewMode === OPEN_VIEWS_MODES.desktop;
  // #!endif
  return result;
};

const normalOpenViews = combineReducersWithGlobal(createFromJS.OpenViewsRecord({}), {
  byId,
  layout,
  activeView
});

const crossModeOpenViews = combineReducersWithGlobal(createFromJS.OpenViewsRecord({}), {
  byId: byIdModesCrossReducer,
  layout: state => state,
  activeView: state => state
});

const getOpenViewsReducer = openViewMode => {
  return doesOpenViewModeMatchCurrentMode(openViewMode) ? normalOpenViews : crossModeOpenViews;
};

export { getOpenViewsReducer };
